import colors from '../base/colors';

const { background } = colors;
const pickersLayout = {
  styleOverrides: {
    root: {
      backgroundColor: background.default
    }
  }
};

export default pickersLayout;
